import { initWidget } from '../../utils/Shell';
import './../../plugins/vee-validate';
import ContactForm from '../../components/ContactForm.vue';

initWidget('ContactFormWidget', ContactForm);
